export class SuggestedFieldOfInterest {
  constructor(
    public fieldOfInterest: string,
    public email: string,
    public description = '',
    public id = '',
    public uid = ''
  ) {}
}
